// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clinical-figure-wrapper {
  position: relative;
  width: 100%;
  height: 380px;
  padding-bottom: 33%;
}
.clinical-figure-wrapper[role='button'] {
  cursor: default !important;
}
.clinical-figure-wrapper:focus {
  outline: none;
}
.clinical-figure-wrapper .clinical-figure-container {
  display: flex;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.clinical-figure-wrapper .clinical-figure-container .clinical-figure-list {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  flex: 1 0 200px;
  max-height: 450px;
  overflow-x: auto;
  list-style: none;
  padding: 0;
  margin: 0;
}
.clinical-figure-wrapper .clinical-figure-container .clinical-figure-list .clinical-figure-list-item {
  width: 200px;
  padding: 5px 10px;
  background-color: #f4f7f6;
  margin-bottom: 5px;
  margin-right: 5px;
}
.clinical-figure-wrapper .clinical-figure-container .clinical-figure-list .clinical-figure-list-item .clinical-figure-icon-remove {
  cursor: pointer;
  float: right;
  padding: 3px;
}
.figure-overlay-wrapper {
  flex: 0 0 300px;
  padding: 0 30px;
}
.figure-overlay-wrapper .clinical-figure {
  width: 300px;
}
@media screen and (max-width: 1024px) {
  .figure-overlay-wrapper .clinical-figure {
    width: 100%;
  }
}
.figure-overlay-wrapper .clinical-figure .outlines > path,
.figure-overlay-wrapper .clinical-figure .outlines > ellipse {
  stroke-width: 1.5;
  fill: none;
  stroke: #231f20;
  stroke-miterlimit: 10;
}
.figure-overlay-wrapper .clinical-figure .body-parts > g.active path,
.figure-overlay-wrapper .clinical-figure .body-parts > g.active ellipse {
  fill: #a7e6d7;
}
.figure-overlay-wrapper .clinical-figure .body-parts > g path,
.figure-overlay-wrapper .clinical-figure .body-parts > g ellipse {
  fill: transparent;
  transition: 0.15s fill;
}
.figure-overlay-wrapper .clinical-figure .body-parts > g path.active,
.figure-overlay-wrapper .clinical-figure .body-parts > g ellipse.active {
  fill: #a7e6d7;
}
.figure-overlay-wrapper .clinical-figure.error .body-parts > g path,
.figure-overlay-wrapper .clinical-figure.error > g ellipse {
  fill: #ffffff;
}
.figure-overlay-wrapper .clinical-figure:not([disabled]) .body-parts > g {
  cursor: pointer;
}
.figure-overlay-wrapper .clinical-figure:not([disabled]) .body-parts > g.hover path,
.figure-overlay-wrapper .clinical-figure:not([disabled]) .body-parts > g:hover path,
.figure-overlay-wrapper .clinical-figure:not([disabled]) .body-parts > g.hover ellipse,
.figure-overlay-wrapper .clinical-figure:not([disabled]) .body-parts > g:hover ellipse {
  fill: #a7e6d7;
}
.figure-overlay-wrapper .clinical-figure:not([disabled]) .body-parts > g path.hover,
.figure-overlay-wrapper .clinical-figure:not([disabled]) .body-parts > g ellipse.hover {
  fill: #a7e6d7;
}
.clinical-figure-popover.popover {
  border-radius: 0;
  padding: 0;
  min-width: 200px;
}
.clinical-figure-popover.popover > .popover-content {
  padding: 0;
}
.clinical-figure-popover.popover .clinical-figure-check {
  float: right;
  padding: 8px;
}
.clinical-figure-popover.popover ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.clinical-figure-popover.popover span {
  padding: 5px 10px;
  cursor: pointer;
  display: block;
}
.clinical-figure-popover.popover span:hover {
  background-color: #d8f2ec;
  font-weight: bold;
  text-decoration: none;
}
.modal .figure-overlay-wrapper {
  padding: 0 5px;
}
`, "",{"version":3,"sources":["webpack://./../styleguide/src/components/ClinicalFigure/main.less","webpack://./../styleguide/src/styles/common.less"],"names":[],"mappings":"AAGA;EAEE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;AAHF;AAKE;EACE,0BAAA;AAHJ;AAME;EACE,aAAA;AAJJ;AARA;EAgBI,aAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;AALJ;AAhBA;EAwBM,aAAA;EACA,sBAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EAEA,gBAAA;EACA,UAAA;EACA,SAAA;AANN;AA3BA;EAoCQ,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;AANR;AAlCA;EA2CU,eAAA;EACA,YAAA;EACA,YAAA;AANV;AAaA;EACE,eAAA;EACA,eAAA;AAXF;AASA;EAKI,YAAA;AAXJ;AC5CE;EAAA;ID0DI,WAAA;EAVJ;AACF;AACA;;EAcQ,iBAAA;EACA,UAAA;EACA,eAAA;EACA,qBAAA;AAXR;AAiBQ;;EAGI,aAAA;AAhBZ;AAVA;;EAgCU,iBAAA;EACA,sBAAA;AAlBV;AAoBU;;EACE,aAAA;AAjBZ;AAuBI;;EAGI,aAAA;AAtBR;AA0BI;EAGM,eAAA;AA1BV;AA4BU;;;;EAII,aAAA;AA1Bd;AAgCY;;EACE,aAAA;AA7Bd;AAsCA;EACE,gBAAA;EACA,UAAA;EACA,gBAAA;AApCF;AAiCA;EAMI,UAAA;AApCJ;AA8BA;EAUI,YAAA;EACA,YAAA;AArCJ;AA0BA;EAeI,gBAAA;EACA,SAAA;EACA,UAAA;AAtCJ;AAqBA;EAqBI,iBAAA;EACA,eAAA;EACA,cAAA;AAvCJ;AAyCI;EACE,yBAAA;EACA,iBAAA;EACA,qBAAA;AAvCN;AA4CA;EACE,cAAA;AA1CF","sourcesContent":["@import (reference) '~styleguide/src/styles/variables.less';\n@import (reference) '~styleguide/src/styles/common.less';\n\n.clinical-figure-wrapper {\n  // This div helps its child keep a 1:3 aspect ratio\n  position: relative;\n  width: 100%;\n  height: 380px;\n  padding-bottom: 33%;\n\n  &[role='button'] {\n    cursor: default !important;\n  }\n\n  &:focus {\n    outline: none;\n  }\n\n  .clinical-figure-container {\n    display: flex;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n\n    .clinical-figure-list {\n      display: flex;\n      flex-direction: column;\n      flex-wrap: wrap;\n      flex: 1 0 200px;\n      max-height: 450px;\n      overflow-x: auto;\n\n      list-style: none;\n      padding: 0;\n      margin: 0;\n\n      .clinical-figure-list-item {\n        width: 200px;\n        padding: 5px 10px;\n        background-color: @bkgdBlue;\n        margin-bottom: 5px;\n        margin-right: 5px;\n\n        .clinical-figure-icon-remove {\n          cursor: pointer;\n          float: right;\n          padding: 3px;\n        }\n      }\n    }\n  }\n}\n\n.figure-overlay-wrapper {\n  flex: 0 0 300px;\n  padding: 0 30px;\n\n  .clinical-figure {\n    width: 300px;\n\n    .ipad({\n      width: 100%;\n    });\n\n    .outlines {\n      > path,\n      > ellipse {\n        stroke-width: 1.5;\n        fill: none;\n        stroke: #231f20;\n        stroke-miterlimit: 10;\n      }\n    }\n\n    .body-parts {\n      > g {\n        &.active {\n          path,\n          ellipse {\n            fill: @mint;\n          }\n        }\n\n        path,\n        ellipse {\n          fill: transparent;\n          transition: 0.15s fill;\n\n          &.active {\n            fill: @mint;\n          }\n        }\n      }\n    }\n\n    &.error {\n      .body-parts > g path,\n      > g ellipse {\n        fill: lighten(@red, 50%);\n      }\n    }\n\n    &:not([disabled]) {\n      .body-parts {\n        > g {\n          cursor: pointer;\n\n          &.hover,\n          &:hover {\n            path,\n            ellipse {\n              fill: @mint;\n            }\n          }\n\n          path,\n          ellipse {\n            &.hover {\n              fill: @mint;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.clinical-figure-popover.popover {\n  border-radius: 0;\n  padding: 0;\n  min-width: 200px;\n\n  > .popover-content {\n    padding: 0;\n  }\n\n  .clinical-figure-check {\n    float: right;\n    padding: 8px;\n  }\n\n  ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n  }\n\n  span {\n    padding: 5px 10px;\n    cursor: pointer;\n    display: block;\n\n    &:hover {\n      background-color: @lightMint;\n      font-weight: bold;\n      text-decoration: none;\n    }\n  }\n}\n\n.modal .figure-overlay-wrapper {\n  padding: 0 5px;\n}\n","// Standard, reusable classes for making adjustments to styling. Ideally, these get\n// phased out over time.\n\n// Any screen less than 1024px. NOTE: Works only for normal (non-retina) iPads!\n.ipad(@rules) {\n  @media screen and (max-width: 1024px) {\n    @rules();\n  }\n}\n\n.no-margin {\n  margin: 0;\n}\n\n.pad-left-20 {\n  padding-left: 20px;\n}\n\n.pad-bottom-20 {\n  padding-bottom: 20px;\n}\n\n.pad-bottom-30 {\n  padding-bottom: 30px;\n}\n\n.color-gold {\n  color: @gold;\n\n  &.h3 {\n    color: @gold;\n  }\n\n  .icon {\n    color: @gold;\n  }\n}\n\n.clickable {\n  cursor: pointer;\n}\n\n.disabled-row {\n  color: @gray;\n}\n\n.rotated {\n  transform: rotate(180deg);\n}\n\n.rotated-arrow {\n  margin-left: 5px;\n  padding-top: 3px;\n}\n\n.hint {\n  color: @gray;\n}\n\n.info {\n  color: @tertiaryBlue!important;\n}\n\n// Since most browsers haven't implemented text-overflow support for flexbox,\n// this class can be applied to wrappers for ellipsis overflows.\n.overflow-ellipsis {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
